import { useCallback, useEffect, useState } from "react";
import { getSection, listPlacement } from "./api";
import { notify } from "./notify";
import { placementById } from "./placements";

export default function useSectionPage(id, franchiseId) {
  const [data, setData] = useState(null);
  const [franchise, setFranchise] = useState(null);
  const [version, setVersion] = useState(0);

  const load = useCallback(async () => {
    const result = await getSection(id);
    if (result.Status === true) setData(result);
    else notify(result);
    setVersion((v) => v + 1);
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const section = data && data.section;
  const placementId = section && section.placement;

  useEffect(() => {
    if (!placementId) return;
    listPlacement(placementId, franchiseId).then((result) => result.Status === true && setFranchise(result.franchise));
  }, [placementId, franchiseId]);

  return { section, banners: (data && data.banners) || [], placement: section && placementById(placementId), franchise, version, load };
}
